
"use client";import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ReactNode, Ref } from "react";

interface ContentLayoutProps {
  ref?: Ref<HTMLDivElement>;
  header?: ReactNode;
  content: ReactNode;
  isFluid?: Boolean;
  maxWidth?: string;
}

const ContentLayout = ({
  ref,
  header = <></>,
  content = <></>,
  isFluid = false,
  maxWidth
}: ContentLayoutProps) => {
  const styleObj = isFluid
    ? {
        maxWidth: maxWidth ? maxWidth : "90vw",
      }
    : {};

  return (
    <Container
      className="p-2"
      fluid={isFluid ? true : false}
      style={styleObj}
      ref={ref}
    >
      <Row>
        <Col>{header}</Col>
      </Row>
      <Row>
        <Col>{content}</Col>
      </Row>
    </Container>
  );
};
export default ContentLayout;
